import { makeRequest } from "../http-common";

const AspectDataService = {
  async getById(id) {
    return makeRequest("get", `/aspect/${id}`);
  },

  async getAllByRef(ref) {
    return makeRequest("get", `/aspects/${ref}`);
  },

  async getPolicies(id) {
    return makeRequest("get", `/aspect/${id}/policies`);
  },

  async getRelated(id) {
    return makeRequest("get", `/aspect/${id}/related`);
  },

  async getDetail(id) {
    return makeRequest("get", `/aspect/${id}/detail`);
  },

  async getCode(id) {
    return makeRequest("get", `/aspect/${id}/code`);
  },  

  async sendReview(id) {
    return makeRequest("post", `/aspect/${id}/send_review`);
  },

  async search(term, type) {
    return makeRequest("get", `/aspect/search/${term}/?type=${type}`);
  },

  async setRelationship(target_id, source_id, label, type) {
    return makeRequest("post", `/aspect/${target_id}/relationship/${source_id}?label=${label}&type=${type}`);
  },

  async updateRelationship(source_id, target_id, label, type) {
    return makeRequest("put", `/aspect/${source_id}/${type}/relationship/${target_id}?label=${label}`);
  },

  async getTypes(id) {
    return makeRequest("get", `/aspect/types/${id}`);
  },

  async byType(id) {
    return makeRequest("get", `/aspect/bytype/${id}`);
  },

  async forms() {
    return makeRequest("get", "/aspect/forms");
  },

  async create(form_data) {
    const final = Object.fromEntries(
      Object.entries(form_data).map(([key, val]) => [key, val || null])
    );

    return makeRequest("post", "/aspect", final);
  },

  async update(id, data) {
    return makeRequest("put", `/aspect/${id}`, data);
  },

  async deleteRelationship(relationship_id) {
    return makeRequest("delete", `/aspect/relationship/${relationship_id}`);
  },

  async delete(id) {
    return makeRequest("delete", `/aspect/${id}`);
  },
};

export default AspectDataService;